import Route from 'rise-ui/utils/routing/route.js';

import { service } from '@ember/service';

import { breadcrumb } from 'rise-ui/services/breadcrumb.js';
import { scrollRoot } from 'rise-ui/services/scroll-root.js';
import strings from 'rise-ui/config/strings.js';

@scrollRoot
export default class HelpIndexRoute extends Route {
  @service keywords;

  setHeadTags(model) {
    this.headTags = [
      {
        type: 'meta',
        attrs: {
          name: 'description',
          content: strings['help-search-meta-description'],
        },
      },
      {
        type: 'meta',
        attrs: {
          name: 'keywords',
          content: this.keywords.keywords(),
        },
      },
    ];
  }

  @breadcrumb crumb = 'Topics';
}
